import { IBPTLVote } from '../types'

export const bptlVote = async ({
  data: { emailaddress, county, town, consent }
}: IBPTLVote) => {
  const url = `https://dev.muddystilettos.co.uk/wp-json/muddy/vote-bptl`
  const bptlVoteData = new FormData()
  bptlVoteData.append('email', emailaddress)
  bptlVoteData.append('county', county)
  bptlVoteData.append('town', town)
  bptlVoteData.append('consent', consent)

  const response = await fetch(url, {
    method: 'post',
    body: bptlVoteData
  })

  return response.json()
}

interface ISingleMCSignup {
  emailaddress: string
  county: string
}

export const singleMailchimpSignup = async ({
  emailaddress,
  county
}: ISingleMCSignup) => {
  const url = `https://dev.muddystilettos.co.uk/wp-json/muddy/update-mailchimp`
  const signUpData = new FormData()
  signUpData.append('newcounties[]', county)
  signUpData.append('email', emailaddress)

  return await fetch(url, {
    method: 'POST',
    body: signUpData
  })
    .then(response => response.json())
    .catch(e => e.message)
}
